// extracted by mini-css-extract-plugin
export default {"placeholder":"typ_pla_HuqGq","pulse":"typ_pul_1oijx"};